export default __webpack_public_path__ + "static/media/IT.db260fa3.svg";